import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, STATUS_OPTIONS } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function AllTasksEmployee() {
  const { userRecords, loading } = useData();
  const { user } = useAuth();

  const myTasks = useMemo(() =>
    userRecords.filter((r) => r.user_id === user?.userId),
    [userRecords, user]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>📋 All My Tasks</h1>
        <p>All tasks assigned to you — {myTasks.length} records</p>
      </div>
      <TaskTable 
        tableId={USER_TABLE} 
        records={myTasks} 
        emptyMsg="No tasks assigned to you yet." 
        canComplete 
        statusOptionsOverride={STATUS_OPTIONS}
      />
    </div>
  );
}
